module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_enchilado.f9fd09d3.png";